<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <CalculatorHeader>
        <h2>Help to Buy Mortgage Calculator</h2>
        <h5>NO CREDIT CHECKS!</h5>
        <h5>Fill out a few details to see if you are eligible for Help to Buy</h5>
      </CalculatorHeader>
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="calculator-container">

            <div @keyup="resetCalculation" @change="resetCalculation">

              <h4 class="fcs-fieldset-title">Applicant Details</h4>

              <BooleanChoiceButtons
                  fieldText="Number of applicants"
                  buttonTextLeft="1"
                  buttonTextRight="2"
              >
                <template v-slot:left>
                  <input type="radio" v-model="applicantsCount" :value="1">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="applicantsCount" :value="2">
                </template>
              </BooleanChoiceButtons>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-show="applicantsCount"
                    fieldText="Applicant 1 annual income (including benefits)?"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome1" />
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-show="applicantsCount == 2"
                    fieldText="Applicant 2 annual income (including benefits)?"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome2" />
                </InputElement>
              </transition>

              <transition name="scale-in" mode="out-in">
                <ReturnedValueBox :innerElement=true v-if="totalHouseholdIncome > 0" text="Your household income is: " :value="totalHouseholdIncome" />
              </transition>

              <transition name="fade-x" mode="out-in">
                <div v-if="totalHouseholdIncome > 0">

                  <h4 class="fcs-fieldset-title">Property Details</h4>

                  <InputElement
                      fieldText="What is the property purchase price?<br><p style='font-size:small;'>(Max £600,000 please <a href='https://www.justmortgagebrokers.co.uk/contact/'>speak to us</a> for more details)</p>"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="housePrice" :max="600000"/>
                  </InputElement>

                  <ReturnedValueBox
                      v-if="housePrice > 0"
                      :innerElement=true
                      text="You will need a minimum deposit of: "
                      :value="minDeposit"
                  />

                  <transition name="fade-x" mode="out-in">
                    <BooleanChoiceButtons
                        v-if="housePrice > 0"
                        fieldText="Is this property in any Borough of London?"
                        buttonTextLeft="Yes"
                        buttonTextRight="No"
                    >
                      <template v-slot:left>
                        <input type="radio" value="Yes" v-model="propertyInLondon">
                      </template>
                      <template v-slot:right>
                        <input type="radio" value="No" v-model="propertyInLondon">
                      </template>
                    </BooleanChoiceButtons>
                  </transition>

                  <transition name="fade-x" mode="out-in">
                    <div
                        v-if="housePrice > 0 && propertyInLondon !== ''"
                        class="mb-5"
                    >
                      <InputElement

                          fieldText="Please enter the first part of the property postcode"
                      >
                        <input class="form-control" type="text" v-model="postcode" placeholder="e.g. IP1 or NR22">
                      </InputElement>

                    </div>
                  </transition>

                  <transition name="fade-x" mode="out-in">
                    <div
                        v-show="postcode !== ''"
                        class="mb-5"
                    >
                      <InputElement
                          fieldText="How much extra over the minimum deposit can you provide towards the purchase price?"
                      >
                        <InputTypeNumber currencyPlaceholder v-model="extraDeposit" />
                      </InputElement>

                      <ReturnedValueBox :innerElement=true text="You will need to borrow: " :value="requestedAmountToBorrow" />
                    </div>
                  </transition>

                  <transition name="fade-x" mode="out-in">
                    <InputElement
                        v-show="extraDeposit !== '' && postcode !== ''"
                        fieldText="Please confirm any monthly payments towards loan or HP payments that will remain after your purchase"
                    >
                      <InputTypeNumber currencyPlaceholder v-model="loanPayments" />
                    </InputElement>
                  </transition>

                  <transition name="fade-x" mode="out-in">
                    <InputElement
                        v-show="extraDeposit !== '' && loanPayments !== '' && postcode !== ''"
                        fieldText="Please confirm any credit card balances that will remain after your purchase"
                    >
                      <InputTypeNumber currencyPlaceholder v-model="creditBalance" />
                    </InputElement>
                  </transition>

                  <transition name="fade-x" mode="out-in">
                    <div class="row mt-5" v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )">
                      <div class="col-md-6 col-lg-4 fw-bold">Why are you using the calculator today</div>
                      <div class="col-md-6 col-lg-8 fcs-grid-long">
                        <DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1"></DropdownMenu>
                      </div>
                    </div>
                  </transition>   

                  <transition name="fade-x" mode="out-in">
                    <div class="row mt-5 mb-5" v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )">
                      <div class="col-md-6 col-lg-4 fw-bold">When will you be ready to move forward?</div>
                      <div class="col-md-6 col-lg-8 fcs-grid-long">
                        <DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2"></DropdownMenu>
                      </div>
                    </div>
                  </transition>

                <!-- <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )"
                    fieldText="Name"
                >
                  <input class="form-control calc-form-control" type="text" v-model="listName">
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )"
                      fieldText="Email Address"
                  >
                      <input class="form-control calc-form-control" type="email" v-model="emailAddress">
                  </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <div class="row align-items-center" v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )">
                    <div class="col-md-1">
                        <input type="checkbox" id="privacy" v-model="consent" >
                    </div>
                    <div class="col-md-11">
                        <label for="privacy">I consent to my personal information being processed in accordance with Just Mortgage Brokers <a href="/privacy-policy/" target="_blank">Privacy Policy</a></label>
                    </div>
                </div>
              </transition> -->

                  <transition name="scale-in" mode="out-in">
                    <div
                        v-if="usableAnnualIncome > 0 && ( creditBalance || creditBalance === 0 ) && ( loanPayments || loanPayments === 0 )"
                        class="text-center mt-5 mb-3"
                    >
                      <div class="btn btn-secondary" @click="calculate">CALCULATE</div>
                    </div>
                  </transition>

                </div>
              </transition>

            </div>

            <transition name="fade-y" mode="out-in">
              <div
                  v-if="calcCompleted"
                  class="mt-5"
                  ref="resultsContainer"
              >
                <div class="row mb-3">
                  <div class="col-12 col-md-6 mb-2 mb-md-0">
                    <ResultsContainer class="full-height">
                      <span>You would like to borrow from us:</span>
                      <span class="fcs-price">£{{ formatNumberOutput(requestedAmountToBorrow) }}</span>
                    </ResultsContainer>
                  </div>
                  <div class="col-12 col-md-6 mb-2 mb-md-0">
                    <ResultsContainer class="full-height">
                      <h6>{{this.chance}}</h6>
                    </ResultsContainer>
                  </div>
                </div>

                <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import ReturnedValueBox from '@/components/utilities/returnedValueBox.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    CalculatorHeader,
    DropdownMenu,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    ReturnedValueBox,
    SubmissionForm
  },
  data() {
    return {
      calculatorName: 'help-to-buy-calculator',
      applicantsCount: null,
      annualIncome1: null,
      annualIncome2: null,

      housePrice: null,
      propertyInLondon: '',
      postcode: '',
      extraDeposit: '',
      loanPayments: '',
      creditBalance: null,
      chance: '',
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      dropdownOptionsReason: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
        {
          value: "I'm not ready for a mortgage but am curious about what I could borrow",
          text: "I'm not ready for a mortgage but am curious about what I could borrow"
        },
        {
          value: "I'm starting to save for a house and want to know what to aim for",
          text: "I'm starting to save for a house and want to know what to aim for"
        },
        {
          value: "I need to understand a what I can afford before house shopping",
          text: "I need to understand a what I can afford before house shopping"
        },



      ],

      dropdownOptionsMove: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "12+ months", text: "12+ months"},
        {value: "6-12 months", text: "6-12 months"},
        {value: "In the next 3 months", text: "In the next 3 months"},
        {value: "As soon as possible", text: "As soon as possible"},
      ],
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      const annualIncome = this.multiplyUsableAnnualIncome
      const amountToBorrow = this.requestedAmountToBorrow
      if(annualIncome >= amountToBorrow) {
        this.chance = `You've got a very good chance of getting a Help to Buy Mortgage, contact us for further details`;
      }
      if((annualIncome < amountToBorrow) && (annualIncome > amountToBorrow - 10000)) {
        this.chance = `We may be able to help you get a Help to Buy Mortgage, contact us for further details.`;
      }
      if((annualIncome < amountToBorrow - 10000) && (annualIncome > amountToBorrow - 20000)) {
        this.chance = `We should be able to help but we will need more details to be sure, contact us for further details.`;
      }
      if(annualIncome < amountToBorrow - 20000) {
        this.chance = `We need to take a closer look to confirm that you are eligible, contact us for further details.`;
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    }
  },
  computed: {
    minDeposit() {
      let calculatedHousePrice = this.housePrice ? this.housePrice : 0;
      return (calculatedHousePrice / 100) * 5;
    },
    totalHouseholdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    requestedAmountToBorrow() {
      let calculatedHousePrice = this.housePrice ? this.housePrice : 0;
      let calculatedExtraDeposit = this.extraDeposit ? this.extraDeposit : 0;

      return ((calculatedHousePrice / 100) * 80) - this.minDeposit - calculatedExtraDeposit;
    },
    usableAnnualIncome() {
      let calculatedLoanPayments = this.loanPayments ? this.loanPayments : 0;
      let calculatedCreditBalance = this.creditBalance ? this.creditBalance : 0;

      return this.totalHouseholdIncome - ( (calculatedLoanPayments * 12) + ((( calculatedCreditBalance / 100 ) * 2.5 ) * 12) );
    },
    multiplyUsableAnnualIncome() {
      return this.usableAnnualIncome * 5.5;
    },
    collateMessageBody() {
      const calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Number of applicants: ${this.applicantsCount}
					Applicant 1 income: £${this.formatEmptyMessageFields(this.annualIncome1)}
					Applicant 2 income: £${this.formatEmptyMessageFields(this.annualIncome2)}
					Household income: £${this.totalHouseholdIncome}
					Property purchase price: £${this.housePrice}
					Is property in London? ${this.propertyInLondon}
					Postcode: ${this.postcode}
					Minimum deposit needed: £${this.minDeposit}
					Extra deposit available: £${this.extraDeposit}
					Total amount to be borrowed: £${this.requestedAmountToBorrow}					
					Loan or HP monthly payments: £${this.loanPayments}
					Credit balances: £${this.creditBalance}
					Usable annual income: £${this.usableAnnualIncome}
          Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>